import { FaChevronRight } from "react-icons/fa";
import { EMAIL_TO_USER, TEXT_GREEN } from "../definitions";
import { useEffect, useMemo, useState } from "react";
import { CircularProgress } from "@mui/material";
import { Avatar } from "./Avatar";
import CountUp from "react-countup";
import { Transaction } from "@ckal-software/ckal-lib/dist/apps/kasse1";
import {
  CAndCEmail,
  EMAIL_CASPER,
  EMAIL_CECILIE,
  UserInfoCAndC,
} from "@ckal-software/ckal-lib/dist/common";
import { setBadge } from "../util";

interface StatusProps {
  userInfo: UserInfoCAndC;
  transactions: Transaction[];
  isFetching: boolean;
  onUserSelect(user: CAndCEmail): void;
}

const EASE_IN_DURATION = 1;

export function Status(props: StatusProps) {
  const [casperTransactions, setCasperTransactions] = useState<Transaction[]>(
    []
  );
  const [cecilieTransactions, setCecilieTransactions] = useState<Transaction[]>(
    []
  );

  useEffect(() => {
    setCasperTransactions((curr) => {
      const newTransactions = props.transactions.filter(
        (t) => EMAIL_TO_USER[t.user as keyof typeof EMAIL_TO_USER] === "Casper"
      );

      if (JSON.stringify(curr) !== JSON.stringify(newTransactions)) {
        return newTransactions;
      }

      return curr;
    });
  }, [props.transactions]);

  useEffect(() => {
    setCecilieTransactions((curr) => {
      const newTransactions = props.transactions.filter(
        (t) => EMAIL_TO_USER[t.user as keyof typeof EMAIL_TO_USER] === "Cecilie"
      );

      if (JSON.stringify(curr) !== JSON.stringify(newTransactions)) {
        return newTransactions;
      }

      return curr;
    });
  }, [props.transactions]);

  const casperBalance = useMemo(
    () => casperTransactions.reduce((sum, curr) => sum + curr.amount, 0),
    [casperTransactions]
  );

  const cecilieBalance = useMemo(
    () => cecilieTransactions.reduce((sum, curr) => sum + curr.amount, 0),
    [cecilieTransactions]
  );

  useEffect(() => {
    setBadge(
      (props.userInfo.email === EMAIL_CASPER
        ? casperBalance
        : cecilieBalance) || undefined
    );
  }, [props.userInfo, cecilieBalance, casperBalance]);

  return (
    <div
      style={{
        background: "white",
        borderRadius: 8,
        border: "1px solid rgba(0,0,0,0.1)",
        margin: "24px 12px 12px 12px",
        color: "rgba(0,0,0,0.7)",
        fontSize: 20,
      }}
    >
      <div
        style={{
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        onClick={() => props.onUserSelect(EMAIL_CASPER)}
      >
        <div style={{ display: "flex", alignItems: "center", columnGap: 12 }}>
          <Avatar
            size={32}
            email={EMAIL_CASPER}
            firstname="Casper"
            lastname="Laursen"
          />
          <div>Casper</div>
        </div>
        <div style={{ display: "flex", alignItems: "center", columnGap: 16 }}>
          <div style={{ textAlign: "end", whiteSpace: "nowrap" }}>
            {props.isFetching && props.transactions.length === 0 ? (
              <CircularProgress
                size={20}
                style={{ marginRight: 4, marginBottom: -2 }}
              />
            ) : (
              <div>
                <CountUp
                  preserveValue
                  end={casperBalance}
                  duration={EASE_IN_DURATION}
                  style={{
                    color: casperBalance > 0 ? TEXT_GREEN : undefined,
                  }}
                />
                <div
                  style={{
                    color: casperBalance > 0 ? TEXT_GREEN : undefined,
                    display: "inline-block",
                    marginLeft: 5,
                  }}
                >
                  kr.
                </div>
              </div>
            )}
          </div>
          <FaChevronRight style={{ fontSize: 16 }} />
        </div>
      </div>
      <div style={{ borderTop: "1px solid rgba(0,0,0,0.1)" }} />
      <div
        style={{
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        onClick={() => props.onUserSelect(EMAIL_CECILIE)}
      >
        <div style={{ display: "flex", alignItems: "center", columnGap: 12 }}>
          <Avatar
            size={32}
            email={EMAIL_CECILIE}
            firstname="Cecilie"
            lastname="Dahlgaard"
          />
          <div>Cecilie</div>
        </div>
        <div style={{ display: "flex", alignItems: "center", columnGap: 16 }}>
          <div style={{ textAlign: "end", whiteSpace: "nowrap" }}>
            {props.isFetching && props.transactions.length === 0 ? (
              <CircularProgress
                size={20}
                style={{ marginRight: 4, marginBottom: -2 }}
              />
            ) : (
              <div>
                <CountUp
                  preserveValue
                  end={cecilieBalance}
                  duration={EASE_IN_DURATION}
                  style={{
                    color: cecilieBalance > 0 ? TEXT_GREEN : undefined,
                  }}
                />
                <div
                  style={{
                    color: cecilieBalance > 0 ? TEXT_GREEN : undefined,
                    display: "inline-block",
                    marginLeft: 5,
                  }}
                >
                  kr.
                </div>
              </div>
            )}
          </div>
          <FaChevronRight style={{ fontSize: 16 }} />
        </div>
      </div>
    </div>
  );
}
